import { render } from "./multilevel.vue?vue&type=template&id=72bfde81&scoped=true"
import script from "./multilevel.vue?vue&type=script&lang=js"
export * from "./multilevel.vue?vue&type=script&lang=js"

import "./multilevel.vue?vue&type=style&index=0&id=72bfde81&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bfde81"]])

export default __exports__